/**
 *  Filename ....: mailmessages.component.ts
 *  Created by ..: ianday
 *  on Date .....: 1/10/24
 **/
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MessageDefinition } from "../../../../models/message-definition";
import { MatTableDataSource } from "@angular/material/table";
import { MessageDefinitionService } from "../../../../services/messages.service";
import { Settings } from "../../../../services/settings";
import { DwUtils } from "../../../../components/utils/dw-utils";
import { NewMessageComponent } from "./newmessage/newmessage.component";
import { MessagesSent } from "../../../../models/messages-sent";
import { ServiceRequestsService } from "../../../../services/service-requests.service";
import { GeneralSetting } from 'src/app/models/generalsetting';

@Component({
	selector: 'app-mailmessages',
	templateUrl: './mailmessages.component.html',
	styleUrls: ['./mailmessages.component.css']
})

export class MailMessagesComponent implements OnInit {

	public displayedColumns = ['dateSent', 'subject']
	public selectedRecord: any;
	public _caseId: number;
	public _selectedRequest: any;
	public restrictedAgencyFlag =false;

	public records: any;
	public dataSource: MatTableDataSource<any>;
	public Idx: number = -1;

	public _tableName: string;
	public memberId: number = -1;
	public agencyId: number;
	public agencyName: string;
	public busyCursor: boolean = false;
	public _readOnly: boolean = false;


	public openNewMailDialog: boolean = false;

	@Input() set readOnly(val: boolean) {
		this._readOnly = val;
	}
	@Input() set selectedRequest(val: any) {
		this._selectedRequest = val;
	}
	get selectedRequest(): any {
		return this._selectedRequest;
	}
	@Input() set caseId(val: number) {

		if (val !== undefined) {
			this._caseId = val;
		}
	}
	get caseId(): number {
		return this._caseId;
	}

	@Input() set tableName(val: string) {

		if (val !== undefined) {
			this._tableName = val;
		}
	}
	get tableName(): string {
		return this._tableName;
	}

	fromSource: string;
	@Input() set from(value: string) {
		this.fromSource = value;
	}

	@ViewChild('newMessage', { static: true }) newMessage: NewMessageComponent;
	public enableEmail = false;
	enableEmailSetting: GeneralSetting;
	public sendMessages: boolean = true;
	public showAllAgencyMessages = false;
	public showRestrictedAgencyMessages = false;
	public showPersonalizedEmail = false;

	constructor(public messageService: MessageDefinitionService) {

	}

	ngOnInit() {
		this.enableEmailSetting = Settings.getInstance().getGeneralSettingByKey('EnableEmail');
		if (this.enableEmailSetting && this.enableEmailSetting !== undefined && this.enableEmailSetting !== null && this.enableEmailSetting.value === 'true') {
			this.enableEmail = true;
		} else {
			this.enableEmail = false;
		}
	}
	setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.showAllAgencyMessages = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_EMAILS_ALL', "SHOW");
			this.showRestrictedAgencyMessages = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_EMAILS_AGENCY_ONLY', "SHOW");
			this.sendMessages = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_EMAILS_SEND', "SHOW");
			this.showPersonalizedEmail = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_EMAILS_SEND_PERSONALIZE', "SHOW");

		} else if (this.fromSource === 'requests') {
			this.showAllAgencyMessages = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EMAILS_ALL', "SHOW");
			this.showRestrictedAgencyMessages = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EMAILS_AGENCY_ONLY', "SHOW");
			this.sendMessages = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EMAILS_SEND', "SHOW");
			this.showPersonalizedEmail = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_EMAILS_SEND_PERSONALIZE', "SHOW");
		} else {
			this.showAllAgencyMessages = true;
			this.showRestrictedAgencyMessages = true;
			this.sendMessages = true;
			this.showPersonalizedEmail = true;
		}
		if(this.showAllAgencyMessages === false && this.showRestrictedAgencyMessages === true){
			this.restrictedAgencyFlag = true;
		}
	}
	public onShowHandler(): void {

		//this.tableName = 'ServiceRequests';
		this.setSecurityPrivileges();
		this.memberId = -1;
		this.Idx = -1;
		this.selectedRecord = new MessagesSent();
		this.queryRecords();
		/* this.fetchMemberIdForCase(this.caseId); */
	}

	public queryRecords(): void {
		if(this.showAllAgencyMessages===false &&this.showRestrictedAgencyMessages===false){
			return;
		}
		this.busyCursor = true;

		this.messageService.getMessagesSentByFKey(this.tableName, this.selectedRequest.id,this.restrictedAgencyFlag).subscribe(
			(results) => {
				this.records = [];
				for (let rec of results) {
					rec.dateSent = DwUtils.formatDTFromDate(new Date(rec.dateSent));
					this.records.push(rec);
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.busyCursor = false;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching sent messages');
				this.busyCursor = false;
			}
		)
	}

	public lblFunction(inpdate: string): string {
		if (inpdate === undefined) {
			return '';
		}
		return DwUtils.formatDTFromString(inpdate);
	}
	public openMailDialog(): void {
		this.openNewMailDialog = true;
		this.newMessage.doShowHandler(this._caseId);              /** member Id in memberId **/
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.setSelectedRow(this.dataSource.filteredData[++this.Idx]);

			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.setSelectedRow(this.dataSource.filteredData[--this.Idx]);
			}
		}
	}
	public onRowClicked(selected: any) {

		this.setSelectedRow(selected);
		this.selectedRecord.dateSent = this.lblFunction(selected.dateSent);
		this.selectRow();
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public setSelectedRow(selected: any): void {
		this.selectedRecord = selected;
		this.selectedRecord.dateSent = this.lblFunction(selected.dateSent);

	}
	public submitNewMessage(record: any): void {

		/** push this record to the top of the stack. **/
		if ((record === null) || (record === undefined)) {
			return;
		}
		record.dateSent = DwUtils.formatDTFromDate(new Date(record.dateSent));
		this.records.unshift(record);
		this.dataSource = new MatTableDataSource(this.records);

		this.openNewMailDialog = false;
	}
	public limitText(inpText: string): string {

		if ((inpText === undefined) || (inpText === null)) {
			return '';
		}

		return inpText.substr(0, 60);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRecord = new MessageDefinition();
	}
}


